import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { CountrySettingsService } from '../services/country-settings.service';
import {
  fetchConversionRate,
  loadedConversionRate,
  failedConversionRate,
  updateConversionRateFilter,
} from './conversion-rate.actions';
import { selectConversionRateFilter } from './conversion-rate.selector';

@Injectable()
export class ConversionRateEffect {
  loadConversionRate$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchConversionRate),
      switchMap(({ filter }) =>
        this.countrySettingsService.getConversionRate(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedConversionRate({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedConversionRate();
            }
          }),
          catchError(() => of(failedConversionRate()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateConversionRateFilter),
      concatLatestFrom(() => this.store.select(selectConversionRateFilter)),
      switchMap(([action, prevFilter]) =>
        of(
          fetchConversionRate({
            filter: { ...prevFilter, ...action.filter },
          })
        )
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly countrySettingsService: CountrySettingsService
  ) {}
}
